import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Song and dance",
  "description": "",
  "published": "2007-03-27T00:00:00.000Z",
  "redirect_from": ["/blog/song-and-dance/swizec/253"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Yesterday upon arriving to my abode and checking `}<a parentName="p" {...{
        "href": "http://myspace.com/swizec"
      }}>{`myspace`}</a>{`, which I do now and anon, believe it or not, I was greeted by a friend invite and a message from one`}<a parentName="p" {...{
        "href": "http://profile.myspace.com/index.cfm?fuseaction=user.viewprofile&friendid=58513191"
      }}>{` Lionel Lodge`}</a>{`. He was offering his new song about `}<a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/Adrian_Monk"
      }}>{`Monk`}</a>{` to all the fans, or anyone really, who would like to hear it. Haven't actually had the chance to give it a listen yet but it just seems like such a nice gesture to be offering something like music for free even though it's merely for promotional purposes.`}</p>
    <p>{`Another thing that's really biting at my nerves right now is how schools appear to have a complete lack of thought for students who might actually like a keyboard that can be used in proper quick typing and not having to have a deadly waltz with it every bloody time.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      